// extracted by mini-css-extract-plugin
export var splitLeftText = "noCtaSplits-module--split-left-text--59b6d";
export var splitterContentLeft = "noCtaSplits-module--splitter-content-left--4fe61";
export var splitterContentRight = "noCtaSplits-module--splitter-content-right--ac03e";
export var splitterLeft = "noCtaSplits-module--splitter-left--af957";
export var splitterLeftImage = "noCtaSplits-module--splitter-left-image--6ffab";
export var splitterLeftWrap = "noCtaSplits-module--splitter-left-wrap--b8ccc";
export var splitterRight = "noCtaSplits-module--splitter-right--013a8";
export var splitterRightImage = "noCtaSplits-module--splitter-right-image--95014";
export var splitterRightWrap = "noCtaSplits-module--splitter-right-wrap--6bb3a";